import type { UUID } from '@cobliteam/common-types';
import useDriverFaceCluster from '@cobliteam/hooks/src/useCamera/useDriverFaceCluster';
import Avatar, { AvatarFallback, AvatarImage } from '@cobliteam/ui/components/Avatar';
import Icon from '@cobliteam/ui/icons';
import { useEffect, useState } from 'react';
import { getInitials } from '../../utils';

interface SelectItemDriverProps {
  id: UUID;
  name: string;
  isSelected?: boolean;
}

const SelectItemDriver = ({ id, name, isSelected }: SelectItemDriverProps) => {
  const [fetchFaceId, setFetchFaceId] = useState(false);
  const isDriver = id !== 'no-driver';

  const { getDriverFaceCluster } = useDriverFaceCluster();
  const { data: cluster, isFetched } = getDriverFaceCluster(id, { enabled: fetchFaceId && isDriver }, true);

  const getAvatarFallback = () => {
    if (isDriver) {
      return isFetched ? getInitials(name) : <Icon className='animate-spin' name='loader-circle' />;
    }

    return <Icon name='user-round' />;
  };

  // The cluster is only fetched when the user hovers over a driver in the list.
  // This prevents unnecessary cluster loading while scrolling through the select options.
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setFetchFaceId(true);
    }, 700);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className={'flex w-full items-center justify-between gap-2.5'}>
      <div className='flex items-center gap-2.5'>
        <Avatar className='size-8'>
          <AvatarImage src={cluster?.profileImageUrl.imageUrl} />
          <AvatarFallback>{getAvatarFallback()}</AvatarFallback>
        </Avatar>
        {name}
      </div>
      {isSelected && <Icon name='check' />}
    </div>
  );
};

export default SelectItemDriver;
